<template>
  <div class="container">
    <Header :stationList="stationList" @onSearch="onSearch"></Header>
    <CheckInfo :station="selectedStation" @getLatest="onSelect"></CheckInfo>
    <template v-if="stationList.length > 0">
      <Map :stationList="stationList" @onSelect="onSelect"></Map>
    </template>
    <el-empty description="暂无充电站数据" v-else></el-empty>
  </div>
</template>

<script>
import Map from "./component/Map.vue";
import Header from "./component/Header.vue";
import CheckInfo from "./component/CheckInfo.vue";
import HTTP_STATION from "@/api/station";
export default {
  name: "Station",
  components: {
    Map,
    Header,
    CheckInfo,
  },
  data() {
    return {
      isLoading: false,
      stationList: [],
      elecName: "",
      selectedStation: null,
    };
  },
  async mounted() {
    await this.getStationList();
  },
  methods: {
    onSearch(val) {
      this.elecName = val;
      this.getStationList();
    },
    onSelect(station) {
      this.selectedStation = station;
    },
    async getStationList() {
      try {
        this.isLoading = true;
        var res;
        if (this.elecName.length > 0) {
          res = await HTTP_STATION.getStationPosition({
            elecName: this.elecName,
          });
        } else {
          res = await HTTP_STATION.getStationPosition();
        }

        if (res.code === 200) {
          this.stationList = res.data;
          this.stationList = this.stationList.map((station) =>
            this.randomLocation(station)
          );
        } else {
          this.$message.error(
            typeof res.msg === "string" ? res.msg : "请求出错，请联系管理员"
          );
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    randomLocation(station) {
      const longitudeRange = {
        start: 112.57,
        end: 114.3,
      }; //经度
      const latitude = {
        start: 22.26,
        end: 23.56,
      }; //纬度
      if (station.elecLat === null) {
        let range = latitude.start - latitude.end;
        let randomNum = range * Math.round(Math.random());
        station.elecLat = (latitude.start + randomNum).toFixed(2);
      }
      if (station.elecLng === null) {
        let range = longitudeRange.start - longitudeRange.end;
        let randomNum = range * Math.round(Math.random());
        station.elecLng = (longitudeRange.start + randomNum).toFixed(2);
      }
      return station;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-empty {
    height: calc(100vh - 100px);
  }
}
.container {
  width: 100%;
  height: calc(100vh - 50px);
}
</style>
